import { Box } from '@mui/material';
import { FC, useRef } from 'react';

import { useOutsideClick } from '../ActionFooter/use-outside-click';

import { CarDetailsPopoverProps } from './car-details-popover.types';
import {
  cardDetailsPopoverChildContainerStyling,
  cardDetailsPopoverWrapperStyling,
} from './CarDetailsPopover.Styling';

export const CarDetailsPopover: FC<CarDetailsPopoverProps> = ({
  children,
  parts,
  onPopOverClick,
  toggleRef,
}) => {
  const popOverReference = useRef<HTMLDivElement>(null);

  useOutsideClick(
    popOverReference,
    () => {
      onPopOverClick(false);
    },
    toggleRef,
  );

  const CustomElement = parts?.customElement;

  return (
    <>
      <Box sx={cardDetailsPopoverWrapperStyling} />
      <Box ref={popOverReference} sx={cardDetailsPopoverChildContainerStyling}>
        {children || (CustomElement && <CustomElement />)}
      </Box>
    </>
  );
};
